import {
  Table,
  Pagination,
  Space,
  Image,
  Button,
  Spin,
  Popconfirm,
} from "antd";
import { numberSeprator } from "../../../utils/number-seprator";

const Admintable = ({
  properties,
  currentPage,
  setCurrentPage,
  loader,
  getPropertyHandler,
  limit,
  setLimit,
  confirm,
  cancel,
  selectedRecord,
  navigate,
  rowSelection,
  onSubmit,
}) => {
  // Table Columns
  const columns = [
    {
      title: "images",
      dataIndex: "ufCrm18PhotoLinks",
      key: "ufCrm18PhotoLinks",
      render: (data) => <Image width={200} src={data && data[0]} />,
    },
    {
      title: "Reference #",
      dataIndex: "ufCrm18ReferenceNumber",
      key: "ufCrm18ReferenceNumber",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Property #",
      dataIndex: "title",
      key: "title",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Title",
      dataIndex: "ufCrm18TitleEn",
      key: "ufCrm18TitleEn",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Price",
      dataIndex: "ufCrm18Price",
      key: "ufCrm18Price",
      render: (data) => <Space size="middle">{numberSeprator(data)}</Space>,
    },
    {
      title: "Property Type",
      dataIndex: "ufCrm18PropertyType",
      key: "ufCrm18PropertyType",
      render: (data) => <Space size="middle">{data?.toUpperCase()}</Space>,
    },
    {
      title: "Offering Type",
      dataIndex: "ufCrm18OfferingType",
      key: "ufCrm18OfferingType",
      render: (data) => <Space size="middle">{data?.toUpperCase()}</Space>,
    },
    {
      title: "Status",
      dataIndex: "ufCrm18Status",
      key: "ufCrm18Status",
      render: (data) => <Space size="middle">{data?.toUpperCase()}</Space>,
    },
    {
      title: "Location",
      key: "ufCrm18Location",
      dataIndex: "ufCrm18Location",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Action",
      key: "",
      render: (data) => (
        <div className="flex">
          <div className="d-flex">
            {data?.id === selectedRecord ? (
              <Spin />
            ) : (
              <>
                <Popconfirm
                  title="Delete the task"
                  description="Are you sure to delete this task?"
                  onConfirm={() => confirm(data)}
                  onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button className="mx-5">Delete</Button>
                </Popconfirm>
                <Button onClick={() => onSubmit(data)}>Save/Update</Button>
              </>
            )}
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      {/* Table */}
      <Table
        columns={columns}
        dataSource={properties?.properties}
        loading={loader}
        pagination={false}
        scroll={{ x: 1023 }}
        rowKey={(record) => record?.id}
      />
      {!loader && (
        <div className="pagination-container">
          <Pagination
            defaultPageSize={currentPage}
            showSizeChanger={false}
            current={currentPage}
            pageSize={limit}
            total={properties?.totalPropertys}
            onChange={(e) => {
              setCurrentPage(e);
              getPropertyHandler(e);
            }}
            className="pagination"
          />
        </div>
      )}
    </div>
  );
};
export default Admintable;
